module.exports = __webpack_public_path__ + "img/logo2.eab14ea3.png";